import { breakpoints, colors, measure } from "@obs/tokens/index.stylex.ts";
import * as stylex from "@stylexjs/stylex";

import { TitlePrimary } from "./variants/TitlePrimary";

export type TheVoiceProps = {
	children: React.ReactNode;
	textAlign?: "center" | "start";
	inverted?: boolean;
};

const styles = stylex.create({
	root: {
		display: "flex",
		flexDirection: "column",
		paddingInline: measure.spacingHorizontalDefault,
		whiteSpace: "pre-line",
		paddingBlock: {
			default: `${measure.spacingVerticalDefault} ${measure.spacingVerticalLarger}`,
			[breakpoints.md]: measure.spacingVerticalLarger,
		},
	},
	center: {
		justifyContent: "center",
	},
	inverted: {
		color: colors.neutralTxtInverted,
	},
	textAlignCenter: {
		textAlign: "center",
	},
});

export const TheVoice = ({ children, textAlign = "start", inverted = false }: TheVoiceProps) => {
	return (
		<div {...stylex.props(styles.root, textAlign === "center" && styles.center)}>
			<TitlePrimary
				inheritColor={inverted}
				sx={[inverted && styles.inverted, textAlign === "center" && styles.textAlignCenter]}
			>
				{children}
			</TitlePrimary>
		</div>
	);
};
